import { render } from "./Clearable.vue?vue&type=template&id=16622999"
import script from "./Clearable.vue?vue&type=script&lang=js"
export * from "./Clearable.vue?vue&type=script&lang=js"
script.render = render

export default script